module.exports = __webpack_public_path__ + "img/Ideas.65a0658e.svg";